import React, { useState } from "react";
import { RCCButton, RCCCheckBox, RCCGrid, RCCIcon, RCCRangeSlider, RCCTooltip } from "react-common-components";
import { Control, FieldErrors, FieldValues, UseFormClearErrors } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import LovIndicators from "../Lov/Indicators";
import SortableHandle from "../Sortable/Handle";
import Title from "../Title";

export interface IIndicatorItem{
    removeIndicator: (index: number) => void;
    register: (RegisterOptions?: any) => void;
    clearErrors: UseFormClearErrors<FieldValues>;
    control: Control<FieldValues>;
    error: FieldErrors<FieldValues>;
    disabled: boolean;
    order: boolean;
    indicator: any;
    index: number;
    names: {
        nameOfObject: string;
        nameOfID: string;
        nameOfSelectIndicator: string;
        nameOfRangeSlider: string;
        nameOfCheckbox?: string;
    }
}

const IndicatorItem: React.FC<IIndicatorItem> = ({
	removeIndicator,
	register,
	clearErrors,
	control,
	indicator,
	disabled,
	order,
	error,
	index,
	names
}) => {
	const { translate } = useTranslation();
	const [indicatorId, setIndicatorId] = useState<number>(indicator.iqc001Id);

	const onChangeIndicator = (item: any) => {
		setIndicatorId(item.value);
		clearErrors(names.nameOfObject);
	};

	return(
		<>
			<RCCGrid
				container
				item
				direction="column"
			>
				<Title color="purple" size="md">
					{index + 1}. {translate("Indicador")}
					{error[`${names.nameOfObject}`] && error[`${names.nameOfObject}[${index}]`] && (
						<span style={{ display: "flex", alignItems: "center", color: "var(--red)", fontSize: "0.8rem", marginLeft: "4px"}}>
							<RCCIcon
								name="infoCircle"
								color="var(--red)"
								style={{ marginRight: "8px"}}
							/>
							{error[`${names.nameOfObject}[${index}]`].message}
						</span>
					)}
				</Title>
				
							
				<RCCGrid
					container
					item
					alignItems="flex-end"
				>
					<input 
						type="text"
						value={indicator.id}
						{...register(`${names.nameOfObject}[${index}].${names.nameOfID}`)} 
						style={{ display: "none" }} 
						readOnly
					/>
					<RCCGrid
						container
						item
						justifyContent="center"
						xs={10}
					>
						<LovIndicators 
							control={control}
							name={`${names.nameOfObject}[${index}].${names.nameOfSelectIndicator}`}
							label=""
							defaultValue={indicator.iqc001Id ? String(indicator.iqc001Id) : undefined}
							error={error[names.nameOfObject] && error?.[names.nameOfObject][index]?.[names.nameOfSelectIndicator]}
							disabled={disabled}
							onChangeCapture={onChangeIndicator}
							styleInline="height: 34px; min-height: 34px;"
						/>
					</RCCGrid>
					<RCCGrid
						container
						item
						justifyContent="flex-end"
						xs={2}
					>
						{
							indicatorId &&
							<RCCTooltip
								color="grey"
								text={translate("Abrir Indicador")}
							>
								<RCCButton
									color="transparent"
									icon={{
										name: "linkExternal",
										color: "var(--grey)"
									}}
									layout="isRounded"
									onClick={() => window.open(`/indicators/panel/${indicatorId}`, "_blank")}
									tabIndex={-1}
								/>
							</RCCTooltip>
						}

						{
							order &&
                                    <SortableHandle>
                                    	<RCCTooltip
                                    		color="grey"
                                    		text={translate("Ordenar")}
                                    	>
                                    		<RCCButton
                                    			color="transparent"
                                    			icon={{
                                    				name: "arrows",
                                    				color: "var(--grey)"
                                    			}}
                                    			layout="isRounded"
                                    			disabled={disabled}
                                    			tabIndex={-1}
                                    		/>
                                    	</RCCTooltip>	
                                    </SortableHandle>
						}

						<RCCTooltip
							color="red"
							text={translate("Excluir")}
						>
							<RCCButton
								color="transparent"
								icon={{
									name: "trash",
									color: "var(--red)"
								}}
								layout="isRounded"
								onClick={() => removeIndicator(index)}
								disabled={disabled}
								tabIndex={-1}
							/>
						</RCCTooltip>
					</RCCGrid>
					{names.nameOfCheckbox && (
						<RCCGrid
							container
							item
							xs={12}
						>
							<RCCCheckBox 
								name={`${names.nameOfObject}[${index}].${names.nameOfCheckbox}`}
								defaultChecked={indicator.checkbox === "S"}
								label={translate("Fator crítico de sucesso")}
								labelPosition="end"
								register={register}
								disabled={disabled}	
							/>
						</RCCGrid>
					)}
					<RCCGrid
						container
						item
						xs={12}
						sm={10}
					>
						<RCCRangeSlider
							control={control}
							name={`${names.nameOfObject}[${index}].${names.nameOfRangeSlider}`}
							color="purple"
							label={translate("Peso")}
							defaultValue={indicator.peso}
							min={0}
							max={100}
							valueLabelDisplay="on"
							marks={[
								{
									value: 0,
									label: "0"
								},
								{
									value: 100,
									label: "100"
								}
							]}
							styleInline=".MuiSlider-valueLabel > span > span{ color: var(--input-font-color); }"
						/>
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</>
	);
};

export default IndicatorItem;
